import React from 'react';
import { Breadcrumb } from 'antd';
import { Container, Title } from './styled';
import { useGetEditorVisible, useUpdateEditorState } from '../../hooks';

export const Nav = () => {
  const userPanel = useGetEditorVisible();
  const resetAction = useUpdateEditorState();
  const items = [
    {
      title: 'User Management',
      onClick: userPanel.isVisible
        ? () => {
            resetAction.resetUserInvite();
            resetAction.resetUserEdit();
            resetAction.resetUsersRevoke();
            resetAction.resetUsersBulkEdit();
          }
        : undefined,
    },
    userPanel.isInviteUserVisible && {
      title: 'Invite User',
    },
    userPanel.isRevokeUsersVisible && {
      title: 'Revoke User',
    },
    userPanel.isEditUserVisible && {
      title: 'Edit User',
    },
    userPanel.isBulkEditVisible && {
      title: 'Edit Permissions',
    },
  ];
  return (
    <Container>
      <Breadcrumb separator=">">
        {items.map((it) => {
          if (!it) return null;
          return (
            <Breadcrumb.Item onClick={it.onClick} key={it.title}>
              <Title clickable={!!it.onClick}>{it.title}</Title>
            </Breadcrumb.Item>
          );
        })}
      </Breadcrumb>
    </Container>
  );
};
